import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import { MutableRefObject } from 'react';
import { useTheme } from '@mui/material/styles';

interface EmailSubjectEditorProps {
  editorRef: MutableRefObject<TinyMCEEditor | null>;
  content: string;
  setContent: (content: string) => void;
  placeholder?: string;
  mergeTags?: unknown;
}

export default function MergeTagOnlyEditor({
  editorRef,
  content,
  setContent,
  placeholder,
  mergeTags,
}: EmailSubjectEditorProps) {
  const theme = useTheme();

  return (
    <>
      <Editor
        apiKey={import.meta.env.VITE_TINYMCE_API_KEY}
        onInit={(_evt, editor) => (editorRef.current = editor)}
        value={content}
        onEditorChange={(newContent) => setContent(newContent)}
        init={{
          placeholder: placeholder,
          skin: theme.palette.mode !== 'dark' ? 'oxide' : 'oxide-dark',
          content_css: theme.palette.mode !== 'dark' ? 'default' : 'dark',
          branding: false,
          height: '100%',
          width: '100%',
          menubar: false,
          toolbar: 'mergetags',
          statusbar: false,
          plugins: 'mergetags',
          // quickbars_insert_toolbar: 'mergetags',
          // quickbars_selection_toolbar: 'false',
          mergetags_prefix: '{|',
          mergetags_suffix: '|}',
          mergetags_list: mergeTags,
          highlight_on_focus: false,
        }}
      />
    </>
  );
}
